import { createSelector } from 'reselect'
import { selectFerryRouteSelectionsState } from '../ferryRouteSelections/selectors'
import { selectLabels } from '../configuration/selectors'

/*
  TODO(ebarrett): This is a stop-gap solution for CAT setting their age ranges
    differently than they are set for NFL/BFL... However, pulling labels from the
    route object would not work in the general case because only one language is 
    included. The passenger type data on the route should be updated to include
    multilingual descriptions, then we can start pulling the data from the route
    objects for all clients. 
*/
export const selectPassengerInputLabels = createSelector(
  selectFerryRouteSelectionsState,
  selectLabels,
  (ferryRouteSelectionsState, labels) => {
    const { passengerTypes } = ferryRouteSelectionsState.departureRoute
    let result = {}

    passengerTypes.forEach(({ code, description }) => {
      let typeString, agesString
      const firstSpaceIndex = description.indexOf(' ')
      if (firstSpaceIndex > -1) {
        // Format expected is "Adult (18 to 65 Years)"
        typeString = description.substring(0, firstSpaceIndex)
        agesString = description.substring(firstSpaceIndex)
      } else {
        // Entire description should be placed in upper row
        typeString = description
        agesString = ' '
      }
      result[code] = {
        type: typeString,
        description: agesString
      }
    })
    result.pet = {
      type: labels.petLabel,
      description: labels.petAgeDesc
    }

    return result
  }
)
